import React,{ useEffect, useRef, useState } from "react";
import { RCCAlert, RCCButton, RCCGrid, RCCHookToast, RCCInput, RCCRefModalProps, RCCServicesApi } from "react-common-components";
import { useForm } from "react-hook-form";
import { useParams,useHistory } from "react-router-dom";
import FiltersContainer from "src/components/FiltersContainer";
import Loader from "src/components/Loader";
import ModalSide from "src/components/Modal/styles";
import Permissions from "src/components/Permissions";
import PageTitle from "src/components/PageTitle";
import SidebarCard from "src/components/SidebarCard";
import { ISidebarCardItem } from "src/components/SidebarCard/interface";
import SidebarCardButtons from "src/components/SidebarCard/sidebarCardButtons";
import Title from "src/components/Title";
import { useTranslation } from "src/context/Translations/context";
import { getValidationErrors, standardErrorMessages } from "src/utils/errors";
import { v4 } from "uuid";
import { useAuth } from "src/context/Auth/context";
import Modal from "src/components/Modal";
import AppIcons from "src/components/AppIcons";
import useEffectFetchData from "src/hooks/useEffectFetchData";
import { IReportListItem } from "../Config/interface";
import ReportCard from "./styles";
import { IWdtba005 } from "./interface";
import reportsPermissionsSchema from "./schemas";

const ReportPanel: React.FC = () => {
    
	const params = useParams<{
        grouperIndex: string;
    }>();
	const { translate } = useTranslation();
	const { addToast } = RCCHookToast();
	const {administrator,superUser} = useAuth();
	const [reportGrouperCard,setReportGrouperCard] = useState<Array<ISidebarCardItem>>([]);
	const [grouper,setGrouper] = useState<{id:string,text:string}>();
	const [grouperList,setGroupList] = useState<{id:string,text:string}[]>([]);
	const [reports,setReports] = useState<IReportListItem[]>();
	const [showFilters,setShowFilters] = useState<boolean>(false);
	const [filters, setFilters] = useState<{filter:string}>({ 
		filter: ""
	});
	const [permissions,setPermissions] = useState<IWdtba005[]>();
	const [report,setReport] = useState<IReportListItem>();
	const modalPermissions = useRef<RCCRefModalProps>(null);
	const history = useHistory();

	const {
		register:registerFilters,
		reset:resetFilters,
		handleSubmit:handleSubmitFilters
	}= useForm();

	const {
		register,
		unregister,
		control,
		formState:{errors},
		setError,
		clearErrors,
		reset,
		handleSubmit
	}= useForm();
	
	const submitFilters = (data: any) => {
		setReportGrouperCard([]);
		setFilters({filter:data.filter});
	};

	const submitPermissions = async (data:any) => {
		try {
			clearErrors();
			
			modalPermissions.current?.setLoadingButton();
			const dataForm = {...data};
			
			if(data.permissions && data.permissions.length > 0){
				dataForm.permissions = dataForm.permissions.map((permission: any) => {
					if(typeof permission.wda005Efa005Id === "object")
						return {
							...permission,
							wda005Efa005Id: permission.wda005Efa005Id.value
						};
					if(typeof permission.wda005Efa004Id === "object")
						return {
							...permission,
							wda005Efa004Id: permission.wda005Efa004Id.value
						};
					return permission;
				});
	
				await reportsPermissionsSchema(translate).validate({ ...dataForm }, {
					abortEarly: false
				});
		
				dataForm.permissions = dataForm.permissions.filter((dt: any) => dt.wda005Efa005Id !== 0);
				dataForm.permissions = dataForm.permissions.filter((dt: any) => dt.wda005Efa004Id !== 0);
			}

			await RCCServicesApi.postRequest({
				method: "reports/SavePermissions",
				body: {
					permissions: dataForm.permissions||[],
					reportId: report?.wda002Id
				}
			});

			addToast({
				color: "green",
				description: translate("Permissão alterada com sucesso"),
				title: translate("Sucesso")
			});

			modalPermissions.current?.resetLoadingButton();
			modalPermissions.current?.closeModal();

		} catch (error) {
			modalPermissions.current?.resetLoadingButton();
			if(getValidationErrors(error,setError)){
				addToast({
					title: translate("Erro"),
					description: translate("Verifique os erros no formulário e tente novamente"),
					color: "yellow"
				});
				return;
			}
			
			standardErrorMessages(error, translate("Erro ao salvar permissões"), addToast);
		}
	};

	const { errorFetching, loading } = useEffectFetchData<string[]> (
		"reports/ListGroupers", { ...filters },
		 ({ data : groupers }) => {
			setGrouper(undefined);
			const grouperL = groupers.map((group) => ({id:group,text:!group?translate("Demais relatórios"):group}));
			setGroupList(grouperL);
			if(params.grouperIndex && params.grouperIndex.length > 0 && grouperL[Number(params.grouperIndex)])
				setGrouper(grouperL[Number(params.grouperIndex)]);
		 },
		 [filters]
	);

	const requestReports = async() => {
		try {
			const dataController = await RCCServicesApi.getRequest({
				method: "reports/List",
				urlParameters:{grouper:grouper?.id,active:"S",...filters}	
			});

			const reps = dataController.data.listRecords as IReportListItem[];
			setReports(reps);
			

		} catch (error) {
			standardErrorMessages(error, translate("Erro ao buscar relatórios"), addToast);
		}
	};

	const requestPermissions = async(reportId:string) => {
		try {
			const dataController = await RCCServicesApi.getRequest({
				method: "reports/ListPermissions",
				urlParameters:{reportId}	
			});

			const permis = dataController.data as IWdtba005[];
			await setPermissions(permis);
			modalPermissions.current?.openModal();
		} catch (error) {
			standardErrorMessages(error, translate("Erro ao buscar permissões"), addToast);
		}
	};

	useEffect(() => {
		if(grouper!==undefined){
			requestReports();
			const grouperIdx = grouperList.findIndex((x) => x.id === grouper.id);
			window.history.replaceState(null, "", `/reports/panel/${grouperIdx}`);
		}
	}, [grouper]);

	useEffect(() => {
		if(grouperList){
			setReportGrouperCard(grouperList.map((group,index) => ({
				id: index,
				title: group.text,
				subtitle: "",
				filtered: true,
				selected: params.grouperIndex ? Number(params.grouperIndex)=== index: false
			})));
		}
	}, [grouperList]);

	return (
		<>
			{errorFetching ? (
				<RCCAlert 
					color="red"
					title={translate("Atenção")}
					description={translate("Erro ao carregar dados")}
				/>
			): 
				<>
					{loading ? 
						<Loader /> : 
						<>
							<SidebarCard 
								title={translate("Relatórios")}
								icon={() => <AppIcons name="reports" />}
								content={
									<>
										{grouper &&
								<RCCGrid container item 
									styleInline={
										` 
										display: flex;
										align-items: flex-start; 
										flex-wrap: wrap;
										width: 100%;
										height: fit-content;
									`}
								>
									<PageTitle
										title={`${translate("Agrupador")}: ${grouper.text}`}
									/>
									
									{reports?.map((rep) => (
										<ReportCard key={v4()}>
											<div 
												role="button"
												className="card-body" 
												aria-hidden="true"
												tabIndex={0}
												style={{display:"flex",justifyContent:"space-between"}}
												onClick={() => {history.push(`/reports/view/${rep.wda002Id}`);}}
											>
												<span>{rep.wda002Titulo}</span>
												{(administrator || superUser) &&
													<RCCButton 
														color="transparent" 
														icon={{name:"lock",color:"var(--default-color-font)"}}
														onClick={(e) => {
															e.stopPropagation();
															reset();
															setReport(rep);
															requestPermissions(rep.wda002Id.toString());
														}}
													/>
												}
											</div>
										</ReportCard>
									))
									}
								</RCCGrid>
										}
									</>
								}
								cardClick={async (id) => {
									setGrouper(grouperList[id]);
								}}
								defaultCardSelected={params.grouperIndex ? Number(params.grouperIndex) : undefined}
								cards={reportGrouperCard}
								filterContent={
									<FiltersContainer
										resetFilters={() => resetFilters({
											filter: ""
										})}
										onSubmitFilters={handleSubmitFilters(submitFilters)}
										showFilters={showFilters}
									>
										<RCCGrid
											container
											item
											spacing={1}
										>
											<RCCGrid
												container 
												item
												xs={12}
											>
												<RCCInput
													name="filter" 
													label={translate("Pesquisar")}
													register={registerFilters}
													defaultValue={filters.filter}
												/>
											</RCCGrid>
										</RCCGrid>
									</FiltersContainer>
								}
								buttonsContent={
									<SidebarCardButtons 
										colorFiltersButton={showFilters || filters.filter ? "blue" : "grey"}
										onClickFilters={() => setShowFilters((prevState) => !prevState)}
									/>
								}
							/>
						</>
					}
				</>
			}
			<Modal
				ref={modalPermissions}
				header={{
					title: translate("Permissões"),
					subtitle: report?.wda002Titulo,
					icon: {
						name: "lock"
					}
				}}
				onSubmit={handleSubmit(submitPermissions)}
				styleInline={ModalSide}
			>
				<Title color="grey" 
					size="xs" 
					marginBottom={8}
				>
					{translate("Utilize as permissões para definir quais usuários, ou grupos de usuários, terão acesso a esse relatório")}
				</Title>
				<Permissions
					register={register}
					unregister={unregister}
					control={control}
					error={errors}
					clearErrors={clearErrors}
					permissionsNames= {{	
						nameObject: "permissions",
						nameOfID: "wda005Id",
						nameOfSelectUser: "wda005Efa005Id",
						nameOfSelectGroup: "wda005Efa004Id",
						nameOfSelectPermission: "wda005Permissao",
						nameOfSelectGroupDescription: "efa005Name",
						nameOfSelectUserDescription: "efa004Name",
						defaultValue: permissions
					}}
					permissionType="report"
				/>
			</Modal>
		</>
	);

}; 

export default ReportPanel;
